import { i18n } from "@/setup/i18n-setup";
import { v4 } from "uuid";

export class CustomViewTab {
	uid:string = v4();
	ID:number = 0;
	Name:string = i18n.t("components.view-editor.custom-tabs.new-tab").toString();
	Url:string = "";
	Title:string = "";
	UseDesktopAppAsProxy:boolean = false;

	public constructor(data?:any){
		if (!data) return;
		this.ID = data.ID || 0;
		this.Name = data.Name;
		this.Url = data.Url;
		this.Title = data.Title;
		this.UseDesktopAppAsProxy = data.UseDesktopAppAsProxy || false;
	}

	public getJSON(){
		return {
			ID: this.ID,
			Name: this.Name,
			Url: this.Url,
			Title: this.Title,
			UseDesktopAppAsProxy: this.UseDesktopAppAsProxy
		};
	}
}